import { useContext } from 'react';

import CopyCreativeFieldsContext from './CopyCreativeFieldsContext';

export const useCopyCreativeFields = () => {
  const { hasCopyBuffer, copy, paste } = useContext(CopyCreativeFieldsContext);
  return { hasCopyBuffer, copy, paste };
};
